import { TypedAction } from '@ngrx/store/src/models';
import { ApiResponseCode, LoyaltyResponse } from '@symphony-solo/shared/http/src';
import { authenticateSuccessAction, AuthenticationActionTypes } from '../+state';
import { TokenResult } from '../models';
import { BaseHandler } from './base.handler';

export class SuccessHandler extends BaseHandler {
  public handle(response: LoyaltyResponse<TokenResult>): TypedAction<AuthenticationActionTypes> {
    if (response.soloResponseCode === ApiResponseCode.Success) {
      return authenticateSuccessAction({ tokenResult: response.value });
    }
    return this.nextHandler.handle(response);
  }
}
